import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainLayout from "./layout/MainLayout";
import AuthLayout from "./layout/AuthLayout";
import "./scss/App.scss";
import "./scss/tailwind.css";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import EditContent from "./pages/content/EditContent";
import ViewContent from "./pages/content/ViewContent";
import Loader from "./components/UI/loader/Loader";
import ProtectedInnerRoute from "./route/ProtectedInnerRoutes";


const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const Customers = React.lazy(() => import("./pages/customers/Customers"));
const CustomerEdit = React.lazy(() => import("./pages/customers/CustomerEdit"));
const AddCustomer = React.lazy(() => import("./pages/customers/AddCustomer"));
const Products = React.lazy(() => import("./pages/product/Products"));
const Roles = React.lazy(() => import("./pages/roles/Roles"));
const ProductEdit = React.lazy(() => import("./pages/product/ProductEdit"));
const AddProduct = React.lazy(() => import("./pages/product/ProductAdd"));
const NotFound = React.lazy(() => import("./pages/NotFound"));
const BlankPage = React.lazy(() => import("./pages/BlankPage"));
const Login = React.lazy(() => import("./pages/Login"));
const Contents = React.lazy(() => import("./pages/content/Content"));
const AddContent = React.lazy(() => import("./pages/content/AddContents"));
const Category = React.lazy(() => import("./pages/category/CategoryPage"));
const MediaType = React.lazy(() => import("./pages/mediatype/MediaType"));
const ForgetPassword = React.lazy(() => import("./pages/ForgetPassword"));
const ResetPassword  = React.lazy(() => import("./pages/ResetPassword"));



function App() {
  return (
    <>
    <ToastContainer/>
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route element={<AuthLayout />}>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="/users" element={<ProtectedInnerRoute element={Customers} requiredRoles={["ViewUser"]}/>} />
              <Route path="/users/:id" element={ <ProtectedInnerRoute element={CustomerEdit} requiredRoles={["UpdateUser"]}/>}  />
              <Route path="/users/create" element={ <ProtectedInnerRoute element={AddCustomer} requiredRoles={["AddUser"]}/>}   />
              <Route path="/privileges" element={ <ProtectedInnerRoute element={Roles} requiredRoles={["ViewRoleList"]}/>}  />
              <Route path="/content" element={ <ProtectedInnerRoute element={Contents} requiredRoles={["ViewContent"]}/>} />
              <Route path="/content/add" element={ <ProtectedInnerRoute element={AddContent} requiredRoles={["AddContent"]}/>} />
              <Route path="/content/edit" element={ <ProtectedInnerRoute element={EditContent} requiredRoles={["UpdateContent"]}/>} />
              <Route path="/content/preview" element={ <ProtectedInnerRoute element={ViewContent} requiredRoles={["ViewContent"]}/>} />
              <Route path="/categories" element={ <ProtectedInnerRoute element={Category} requiredRoles={["ViewCategory"]}/>} />
              <Route path="/mediatypes" element={ <ProtectedInnerRoute element={MediaType} requiredRoles={["ViewMediaType"]}/>}  />
              <Route path="/product/products" element={<Products />} />
              <Route path="/product/products/:productId" element={<ProductEdit />} />
              <Route path="/product/products/create" element={<AddProduct />} />
              <Route path="/orders" element={<BlankPage />} />
              <Route path="/analytics" element={<BlankPage />} />
              <Route path="/discount" element={<BlankPage />} />
              <Route path="/inventory" element={<BlankPage />} />
            </Route>
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>

    </BrowserRouter>
    </>
  );
}

export default App;
